import { useEffect } from 'react';
import type { IdentitySession } from '../api';

/**
 * Warms the API up once the page has rendered, so a cold words-happen-gql starts while the player types and the
 * handoff (POST /session) doesn't wait for it. Never delays or blocks the page; `session.warmUpApi` sends at most once.
 */
export const useApiWarmUp = (session: Pick<IdentitySession, 'warmUpApi'>): void => {
  useEffect(() => {
    session.warmUpApi();
  }, [session]);
};
